import { AreaChartOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Flex, Tooltip, Typography, Image, Modal } from 'antd';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import routesConfig from '../../../config/routes';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { getUserBalance } from '../../../utils';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { ReactComponent as LogoutIcon } from '../assets/logout.svg';

const { Text } = Typography;

class _UserProfile extends Component<IRootStoreProps> {
  static contextType = AppContext;
  state = { isModalOpen: false };

  render(): React.ReactNode {
    const { isMobile } = this.context as AppContextValue;
    const { user, auth, game } = this.props.store;
    const balance = getUserBalance(game?.userBalance, user?.data);
    const name = user.data?.login;

    const showModal = () => {
      this.setState({ isModalOpen: true });
    };

    const onCloseModal = () => {
      this.setState({ isModalOpen: false });
    };

    const logout = () => {
      auth.logout();
    };

    return (
      <>
        {user.isAuth ? (
          <>
            <Flex gap="middle" style={{ marginTop: 10 }}>
              <Image src={user.data?.imageUrl} width={40} />
              <Col>
                <Col>
                  <Text>{name}</Text>
                </Col>
                <Col>
                  <Flex align={'flex-end'}>
                    <Text style={{ fontSize: 12, fontWeight: 300, marginRight: 10, paddingBottom: 3 }}>
                      {'БАЛАНС:'}
                    </Text>
                    <Text style={{ fontSize: 16, fontWeight: 600 }}>{balance}</Text>
                  </Flex>
                </Col>
              </Col>
            </Flex>
            <Flex gap="middle" style={{ marginTop: 10 }} vertical={isMobile}>
              <Link to={routesConfig.userDepositBalance}>
                <Button type="primary" style={{ height: 30 }}>
                  Пополнить
                </Button>
              </Link>

              <Link to={routesConfig.userRemoveBalance}>
                <Button type="primary" style={{ height: 30 }}>
                  Вывести
                </Button>
              </Link>
            </Flex>
            <Flex gap="middle" style={{ marginTop: 10 }}>
              <Tooltip title="Настройки" placement="bottom">
                <Link to={routesConfig.userSettings}>
                  <Button color="primary" variant="outlined" icon={<SettingOutlined />} />
                </Link>
              </Tooltip>
              <Tooltip title="Статистика" placement="bottom">
                <Link to={routesConfig.userStatistic}>
                  <Button color="primary" variant="outlined" icon={<AreaChartOutlined />} />
                </Link>
              </Tooltip>
              <Tooltip title="Выход" placement="bottom">
                <Button color="primary" variant="outlined" onClick={showModal} icon={<LogoutIcon />} />
              </Tooltip>
            </Flex>
            <Modal
              title="Выйти?"
              open={this.state.isModalOpen}
              onOk={logout}
              onCancel={onCloseModal}
              okText={'Да'}
              cancelText={'Нет'}
              width={200}
            />
          </>
        ) : (
          <>
            <Col>
              <Avatar shape="square" size="large" icon={<UserOutlined />} />
            </Col>
            <Flex gap="small" style={{ marginTop: 30 }}>
              <Link to={routesConfig.login}>
                <Button>Вход</Button>
              </Link>
              <Link to={routesConfig.registration}>
                <Button>Регистрация</Button>
              </Link>
            </Flex>
          </>
        )}
      </>
    );
  }
}

export const UserProfile: WithoutStore = withStore(observer(_UserProfile));
